module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“T")])]), _vm._v("urn your head, if you please, Your Grace.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adrian Warfield, Duke of Windmere, suffered the poking and prodding in silence. His name and position had brought three of England’s leading physicians to his home, and his inbred manners prevented him from allowing the escape of the oaths he wanted to speak. If these three men could give him no answers, his future and that of his family and dukedom looked increasingly bleak. Allowing each of them in turn a chance to examine him, Adrian grew impatient when it seemed that the appointment dragged on for too long.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Finally, finally, they stepped away and he adjusted his shirt and waistcoat. Leaving the ends of his linen cravat hanging down on his chest, Adrian waited for their pronouncement. They stood in a cluster by his desk, whispering among themselves and glancing at him as they consulted on his condition.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, Doctors. What is your diagnosis?” He liked none of the expressions that met his gaze. The silence grew until it made his skin itch, and he spat out one of the curses he’d held in until that moment. “Bloody hell! Just get on with it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They looked to each other before facing him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your Grace, we have nothing new to offer you regarding your condition,” Dr. Penworthy said. His bushy eyebrows twitched, giving him a vaguely squirrel-like appearance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But it has worsened?” Adrian prepared himself for the worst.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It has, Your Grace, but not so much that we are overly concerned by the changes you presented.” Dr. Lloyd pulled out a small notebook and nodded at the desk. “An adjustment or two to the tonics you are using should be just the thing to deal with the symptoms.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adrian stepped aside and allowed Dr. Lloyd to sit in his chair and write out instructions to the apothecary. Although Drs. Penworthy and Wilkins exchanged glances again, neither had any other recommendations and allowed Dr. Lloyd to speak for them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your Grace, do not let these changes affect you so much. We know that a nervous personality will exacerbate your lung condition.” All three nodded in agreement and Adrian scowled in response at each of them individually. Dr. Lloyd held out the paper to him with the scrawled instructions. “Take the waters a few times this summer and you will feel like a new man.”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Closing his eyes for a moment, Adrian fought for control over his frustration. No need to give the impression that he had the nervous personality they’d spoken of. No need to let on that he would like to strangle them all. Anger pulsed within him, alive, potent and growing. With an astuteness that surprised him, the three older men met his gaze directly. They knew how helpless he felt in the face of his condition. And helpless was not how a man wanted to feel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We will see ourselves out, Your Grace,” Dr. Wilkins said softly. “We are at your service if the need arises.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adrian accepted their bows and watched wordlessly as they opened the door and left. Realizing that he was crumbling the paper in his fist, he smoothed it open and tossed it on his desk. Walking to the other end of his study, he looked out the window at the bright, clear day before him. Dropping into the high-backed chair near the window, he tried to release the tension that spiraled inside him. They were correct about that—allowing the anger and frustration free rein did increase the number and severity of the attacks.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Leaning his head back, he closed his eyes again and listened to the sounds outside his house. The clip-clop of horses. The rustling of the branches of the trees in the spring breeze. The gentle calls of birds. The doctors’ voices.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The doctors’ voices?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Adrian got to his feet and positioned himself next to ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("the open window where he could see and not be seen. The three doctors stood a few yards from him and, though they lowered their voices in a discreet fashion, he heard their every word.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A terrible pity, really.” Lloyd?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And nothing to be done?” That was certainly Wilkins. Adrian shifted to hear better. Who were they discussing?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And in the prime of his life. Sad case.” He could almost picture Penworthy’s eyebrows twitching as he spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Shouldn’t he be told? I do worry about that,” Lloyd admitted in a fretful voice. “There are preparations to be made, arrangements to be handled, and so many rely on his oversight and condescension.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An icy shiver slid down Adrian’s back and he straightened away from the aperture. Beads of sweat gathered on his own brow and trickled down his face and neck. The room had not grown hotter. Fear, plain and clear, caused his body to react to the horrible news, a sense of foreboding that grew within him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It could not be….")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It simply could not be…him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“With his titles and lands, all the crucial details are already handled.” Penworthy continued, “A man with his status and responsibilities, and especially one with no heirs-of-his-body, has everything in order at all times. No, I think it best not to reveal the direness of his true situation.”")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a pause, as though they were considering Penworthy’s recommendation to keep him unadvised of his perilous condition.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His condition?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shook his head, trying to clear his thoughts, for he must be hearing their words incorrectly. They had just assured him to his face that he was only a slight bit worse. Change his decoctions. Take the waters. They’d not warned him of his impending death.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How long, do you think?” Wilkins asked. “Such a marked deterioration cannot be a good sign.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A half year? Perhaps through the winter? I cannot be more specific than that without an unacceptable amount of conjecture on my part,” Lloyd declared. “We will watch his condition and do what we can to relieve his symptoms. Especially as they worsen.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They paused then and Adrian wiped the sweat from his face with the back of his hand. As their words began to sink into his mind, he shook his head again. It could not be. It simply could not be.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That poor man,” Penworthy said. “The noblest of blood cannot protect you once Death has you marked as his own.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("A moment of silence was all they spared him then. The clattering of wheels on cobblestones and the familiar sound of Adrian’s coachman calling out to his team told him that his carriage had pulled in front of the house to take ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("them back to their respective offices. The vehicle rolled away down the street and he was left with the awful truth.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adrian Warfield, Duke of Windmere, would be dead by the year’s end.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Time had stopped for him, but his death sentence still echoed through the chamber. Stunned by the words spoken by his physicians, Adrian could not think rationally. Scattered thoughts and memories flooded his mind as he tried to grab on to something that would make sense of this insanity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Long ago, when discussing with his older brother the bravery of soldiers facing death, he had thought in a fleeting way of how he would handle himself if ever in that situation. Now, the courage and daring spoken of then disappeared, and a raw, gut-wrenching fear tore at him, making his legs quiver and his stomach churn.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He did not know how long the inertia of shock held him prisoner in the chair, simply breathing in and out to keep the prophesy of his death at bay. Dust motes floated before him and the sounds of the street outside his windows faded away. Aware of only the growing turmoil within, he stared off into the distance and waited for it to hit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And, like an unprovoked punch in the gut, it did.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("As the news began to settle in, Adrian stumbled to the cabinet, grabbed the crystal decanter of port and lurched from his study. Ignoring the startled looks of his man-of-business and his butler, he strode to the stairs and climbed to the second floor, where his rooms were ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("located. Bolting past his valet, he slammed the door and locked it behind him.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He put the port down on the table next to his bed and pulled his cravat from around his neck. Tugging at the buttons, he ripped his waistcoat off and then threw it across the room. Loosening his shirt, he tried to calm himself with a few deep breaths. The coughing spasms he feared were on him instantly and he doubled over from the strength of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Minutes went by as hours while the very breath was squeezed from his lungs, but finally he could feel the spasms lessen. Collapsing on his bed, he pulled air into his body, fighting not to lose consciousness. The banging on the door drew his attention and he heard his valet’s loud whisper through the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your Grace? Your Grace?” Thompson’s voice was filled with concern, a concern that Adrian did not want at this moment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Leave me be, Thompson. I am well,” he called out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Coughing again, he lay back on the bed’s cool surface and waited for the attack to end. A few more spasms and a number of coughs and then it ceased. Adrian pushed himself up, shrugged off his waistcoat and reached for the port. In a move that he knew would horrify his servants and his wife if they ever witnessed it, he brought the decanter to his mouth and swallowed several mouthfuls of the fortified wine.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Leaning back against the mahogany headboard, he listened to the sounds of whispering outside his door. ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Two—no, three—people were out there trying to decide what to do about him, and he guessed the group included Thompson, his valet, Sherman, his butler, and perhaps even Webb, his secretary and man-of-business, whose meeting had been cut short with the arrival of the physicians.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No matter. Adrian could not face them until he faced himself and accepted what the doctors had told him. And that called for the consumption of as much distilled spirits as he could handle. Or not handle. He looked at the bottle in his hand and wondered if there was enough port there for his needs. There was always the twenty-five-year-old whisky in the locked cabinet—that would more than meet his requirements.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Adrian lifted the bottle again to his mouth and drank deeply. The warmth settled his stomach and began to spread out to his limbs. Unable to face the reality of his all-too-short future, he decided to drink until the news was blotted from his thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Smiling grimly, he realized he would need to break into his late father’s private stock for something stronger to deaden the shock of the news of his own impending demise. Facing death was not as easy as he had imagined all those years ago.")])])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page16"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-830fcf00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426878497_ch01.vue
// module id = 78
// module chunks = 0